function getShadowY(elevation) {
  return elevation * 0.5;
}

function getShadowBlur(elevation) {
  if (elevation < 8) {
    return elevation * 1.5;
  } else if (elevation < 16) {
    return elevation * 0.5 + 8;
  }

  return elevation;
}

function getShadowSpread(elevation) {
  if (elevation === 0) {
    return 1;
  }

  return 0;
}

function getOuterShadowValue() {
  var elevation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      color = _ref.color;

  var roundedElev = elevation;

  if (elevation < 0) {
    // When the elevation is smaller than 0, fix elevation to 0.
    roundedElev = 0;
  } else if (!Number.isInteger(elevation)) {
    // When the elevation is floating value, round it.
    roundedElev = Math.round(elevation);
  }

  var x = 0;
  var y = getShadowY(roundedElev);
  var blur = getShadowBlur(roundedElev);
  var spread = getShadowSpread(roundedElev);
  var rgba = color === "black" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)";
  return "".concat(x, "px ").concat(y, "px ").concat(blur, "px ").concat(spread, "px ").concat(rgba);
}

function getInnerShadowValue(_ref2) {
  var color = _ref2.color;
  return "0px 0px 0px 1px rgba(".concat(color === "black" ? "0, 0, 0" : "255, 255, 255", ", 0.02)");
}

export function getElevations() {
  var elevation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$color = _ref3.color,
      color = _ref3$color === void 0 ? "black" : _ref3$color;

  if (elevation == null) return [];
  var innerShadowValue = getInnerShadowValue({
    color: color
  });
  var outerShadowValue = getOuterShadowValue(elevation, {
    color: color
  });
  return [innerShadowValue, outerShadowValue];
}
//# sourceMappingURL=elevation.js.map